import { useRef } from "react"
import { useSelector, useDispatch } from "react-redux"
import { checkDiscountCode } from "store/discounts"

export const useDiscountCodeCheck = ({ form, isEditMode, initialCode }) => {
  const dispatch = useDispatch()
  const isCheckingCode = useSelector((state) => state.discounts.checkCode.loading)
  const duplicateErrorRef = useRef(null)

  const validateCode = (code) => {
    dispatch(checkDiscountCode(code))
      .then((res) => {
        if (res?.exists) {
          duplicateErrorRef.current = res.message
          form.validateFields(["code"])
        } else {
          duplicateErrorRef.current = null
          form.validateFields(["code"])
        }
      })
      .catch((err) => {
        console.error("Failed to check discount code:", err)
      })
  }

  const handleCodeBlur = () => {
    const code = form.getFieldValue("code")
    if (!code) return
    if (isEditMode && initialCode === code) return
    validateCode(code)
  }

  const generateCode = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
    const code = Array.from({ length: 8 }, () => chars[Math.floor(Math.random() * chars.length)]).join("")
    form.setFieldValue("code", code)
    duplicateErrorRef.current = null
    validateCode(code)
  }

  // Called onChange so typing a new code clears the duplicate error immediately
  const handleCodeChange = (e) => {
    form.setFieldValue("code", e.target.value.toUpperCase())
    if (duplicateErrorRef.current) {
      duplicateErrorRef.current = null
      form.validateFields(["code"])
    }
  }

  // Validator rule — included in the code field's rules array
  const duplicateCodeValidator = () => {
    if (duplicateErrorRef.current) {
      return Promise.reject(new Error(duplicateErrorRef.current))
    }
    return Promise.resolve()
  }

  return { isCheckingCode, handleCodeBlur, handleCodeChange, generateCode, duplicateCodeValidator }
}
